export default __webpack_public_path__ + "static/media/costel.0bffb90c.png";